// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"b13ba00c","453":"d6594b12","810":"ef387ae1"}[chunkId] + ".chunk.js";
};